import { useEffect, useState } from "react";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid-pro";

export const useGridState = () => {
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(25);

    const [sortModel, setSortModel] = useState<GridSortModel>([]);

    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [],
    });

    useEffect(() => {
        setPage(0);
    }, [sortModel, filterModel]);

    return {
        page,
        setPage,
        pageSize,
        setPageSize,
        sortModel,
        setSortModel,
        filterModel,
        setFilterModel,
    };
};